// extracted by mini-css-extract-plugin
export default {"flexColumns":"CustomerPortalConsumerDetails_flexColumns__TaHll","box":"CustomerPortalConsumerDetails_box__-0J9p"};